import WikipediaW from '../../src/legacy/WikipediaW';
export default WikipediaW;
